import styled from 'styled-components';
import { Tag } from 'antd';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

export const StyledTag = styled(Tag)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  font-size: 12px;
  font-weight: 500;
  padding: 0px 8px;
  border-radius: 9999px;
  text-align: center;
  &.Verified,
  &.Finished,
  &.Active,
  &.Paid,
  &.Approved,
  &.Success,
  &.Primary,
  &.Confirmed,
  &.Applied,
  &.REGISTRATION_COMPLETE {
    color: ${defaultTheme.theme.palette.success[500]};
    border: 1px solid ${defaultTheme.theme.palette.success[300]};
    background-color: ${defaultTheme.theme.palette.success[50]};
  }
  &.Pending {
    color: ${defaultTheme.theme.palette.neutral[700]};
    border: 1px solid ${defaultTheme.theme.palette.neutral[200]};
    background-color: ${defaultTheme.theme.palette.neutral[50]};
  }
  &.Awaiting,
  &.Outstanding,
  &.Stopped,
  &.Invalid,
  &.WIP {
    color: ${defaultTheme.theme.palette.warning[700]};
    border: 1px solid ${defaultTheme.theme.palette.warning[300]};
    background-color: ${defaultTheme.theme.palette.warning[50]};
  }
  &.Error,
  &.Failed,
  &.Cancel,
  &.Canceled,
  &.Rejected,
  &.Inactive {
    color: ${defaultTheme.theme.palette.error[500]};
    border: 1px solid ${defaultTheme.theme.palette.error[300]};
    background-color: ${defaultTheme.theme.palette.error[50]};
  }

  &.Warning,
  &.Processing {
    color: ${({ theme }) => theme.palette.orange[500]};
    border: 1px solid ${({ theme }) => theme.palette.orange[300]};
    background-color: ${({ theme }) => theme.palette.orange[50]};
  }
  &.New,
  &.Ready,
  &.ONGOING {
    color: ${defaultTheme.theme.palette.blue[500]};
    border: 1px solid ${defaultTheme.theme.palette.blue[300]};
    background-color: ${defaultTheme.theme.palette.blue[50]};
  }
  &.Description {
    color: ${({ theme }) => theme.palette.primary[500]};
    border: 1px solid ${({ theme }) => theme.palette.primary[300]};
    background-color: ${({ theme }) => theme.palette.primary[50]};
  }
  &.Overdue {
    color: ${({ theme }) => theme.palette.violet[500]};
    border: 1px solid ${({ theme }) => theme.palette.violet[300]};
    background-color: ${({ theme }) => theme.palette.violet[50]};
  }
`;
